<button (click)="goToDetail.emit()" class="carte-button" aria-labelledby="indicateur-propriete" appBlurOnMouseClick>
  <div class="carte">
    <div class="top">
      <div class="thermometre" *ngIf="hasThermometre">
        <img
          src="{{ 'assets/images/risques/thermometre-' + couleurIndicateur + '.svg' | cheminAbsoluStatique }}"
          alt=""
          id="thermometre-risque"
        />
      </div>
      <div class="titre" id="indicateur-propriete" (click)="goToDetail.emit()">
        {{ texteIndicateur | translate }}
      </div>
      <div (click)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()">
        <button
          mat-icon-button
          [ngxTippy]="popper1Content"
          [tippyProps]="tippyProps"
          [attr.aria-label]="'propriete.detail.plus' | translate"
          id="btn-carte-propriete-plus"
          class="more-button"
          appBlurOnMouseClick
        >
          <svg class="more-icon" xmlns="http://www.w3.org/2000/svg" width="4" height="20" viewBox="0 0 4 20">
            <g fill="#666666" fill-rule="nonzero">
              <circle cx="2" cy="2" r="2" />
              <circle cx="2" cy="8.923" r="2" />
              <circle cx="2" cy="15.846" r="2" />
            </g>
          </svg>
        </button>
      </div>
    </div>

    <div class="detail-propriete" #popper1Content>
      <button id="btn-voir-detail-carte" class="popover-item" (click)="goToDetail.emit()" type="button">
        {{ 'propriete.btn-voir-detail' | translate }}
      </button>
      <button id="btn-modifier-carte" class="popover-item" (click)="editProperty()" type="button">
        {{ 'btn.modifier' | translate }}
      </button>
      <button
        id="btn-supprimer-carte"
        class="popover-item"
        (click)="$event.stopPropagation(); hidePopover(); deleteProperty()"
        type="button"
      >
        {{ 'propriete.btn-supprimer' | translate }}
      </button>
    </div>

    <div [class]="'body ' + bannerClass" class="bordered-bottom">
      <div class="body-content">
        <div class="overview">
          <div class="image-container">
            <div
              [ngClass]="propriete.photoId ? 'photo' : 'no-photo'"
              [id]="propriete.photoId ? 'photo-propriete' : 'icone-propriete'"
            >
              <img
                *ngIf="!propriete.photoId"
                src="{{ 'assets/images/icone-maison-' + couleurIndicateur + '.svg' | cheminAbsoluStatique }}"
                alt=""
              />
              <img *ngIf="propriete.photoId" [src]="imageDownloadUrl" alt="" />
            </div>
          </div>
          <div class="price-container" id="prix-total-propriete">
            <div class="price dsd-fw-bold">{{ proprieteHelper.prixTotal | desjardinsCurrency }}</div>
            <div class="dsd-b-40 dsd-mb-0" *ngIf="proprieteHelper.hasRenovations">
              ({{ 'propriete.detail.incluant-renovations' | translate }})
            </div>
          </div>
        </div>
        <div class="financial-info" *ngIf="hasThermometre">
          <div class="analysis">
            <div class="frais-mensuels">
              <div class="ligne" id="label-versements-1">{{ 'propriete.detail.montant-versements' | translate }}</div>
              <div class="ligne montant" id="montant-versements-1">
                {{ montantVersementMensuel | desjardinsCurrency }}
                {{ 'general.par-mois' | translate }}
              </div>
              <div class="ligne" id="frais-propriete-1">
                <div *ngIf="montantFraisMensuels > 0" class="frais-estimes">
                  <img
                    src="{{ 'assets/images/alert-triangle.svg' | cheminAbsoluStatique }}"
                    alt="{{ 'general.avertissement' | translate }}"
                    width="16"
                    height="16"
                    *ngIf="proprieteHelper.isFraisIncomplete"
                  />
                  + {{ montantFraisMensuels | desjardinsCurrency }}
                  <span class="small-text-mobile"> ({{ 'propriete.detail.frais-propriete' | translate }})</span>
                </div>
                <div *ngIf="!(montantFraisMensuels > 0)" class="frais-estimes">
                  <img
                    src="{{ 'assets/images/alert-triangle.svg' | cheminAbsoluStatique }}"
                    alt="{{ 'general.avertissement' | translate }}"
                    width="16"
                    height="16"
                  />
                  + {{ 'propriete.detail.frais-estimes' | translate }}
                </div>
              </div>
              <div class="separateur"></div>
              <div class="dsd-fw-bold" id="montant-total-mensuel-1">
                <span [innerText]="montantTotalMensuel | desjardinsCurrency"></span>
                <span>{{ 'general.par-mois' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="financial-info cas-particulier" *ngIf="!hasThermometre">
          <div *ngIf="isBudgetImportant">
            <div class="texte">{{ 'propriete.liste.texte-budget-important' | translate }}</div>
            <div class="cta">
              <app-boite-contact
                buttonStyle="textOnly"
                buttonText="propriete.liste.cta-capacite-particuliere"
              ></app-boite-contact>
            </div>
          </div>
          <div *ngIf="isBudgetInsuffisant">
            <div class="texte">{{ 'propriete.liste.texte-budget-insuffisant' | translate }}</div>
            <div class="cta">
              <app-boite-contact
                buttonStyle="textOnly"
                buttonText="propriete.liste.cta-capacite-particuliere"
              ></app-boite-contact>
            </div>
          </div>
          <div *ngIf="isCapaciteManquante">
            <div class="texte">{{ 'propriete.liste.texte-capacite-incomplete' | translate }}</div>
            <button class="cta text-only-button" (click)="calculateBudget($event)" type="button">
              {{ 'propriete.liste.cta-capacite-incomplete' | translate }}
            </button>
          </div>
          <ng-container *ngIf="isMiseDeFondsInsuffisante">
            <div class="analysis frais-mensuels">
              <div class="ligne" id="label-versements-2">{{ 'propriete.detail.montant-versements' | translate }}</div>
              <div class="ligne montant" id="montant-versements-2">
                {{ 'propriete.liste.non-calcule' | translate }}
              </div>
              <div class="ligne" id="frais-propriete-2">
                <div *ngIf="montantFraisMensuels > 0" class="frais-estimes">
                  <img
                    src="{{ 'assets/images/alert-triangle.svg' | cheminAbsoluStatique }}"
                    alt="{{ 'general.avertissement' | translate }}"
                    width="16"
                    height="16"
                    *ngIf="proprieteHelper.isFraisIncomplete"
                  />
                  + <span [innerText]="montantFraisMensuels | desjardinsCurrency"></span>
                  <span class="small-text-mobile"> ({{ 'propriete.detail.frais-propriete' | translate }})</span>
                </div>
                <div *ngIf="!(montantFraisMensuels > 0)" class="frais-estimes">
                  <img
                    src="{{ 'assets/images/alert-triangle.svg' | cheminAbsoluStatique }}"
                    alt="{{ 'general.avertissement' | translate }}"
                    width="16"
                    height="16"
                  />
                  + {{ 'propriete.detail.frais-estimes' | translate }}
                </div>
              </div>
              <div class="separateur"></div>
              <div class="dsd-fw-bold" id="montant-total-mensuel-2">
                - - $
                <span>{{ 'general.par-mois' | translate }}</span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</button>
